/**
 * HR Module - Shared Constants and Utilities
 */
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const COLORS = ['#10B981', '#3B82F6', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899'];

export const RATING_COLORS = {
  'Cemerlang': '#10B981',
  'Baik': '#3B82F6',
  'Memuaskan': '#F59E0B',
  'Perlu Penambahbaikan': '#F97316',
  'Tidak Memuaskan': '#EF4444'
};

export const MODAL_TITLES = {
  kpi: 'KPI',
  performance: 'Penilaian',
  attendance: 'Kehadiran',
  leave: 'Cuti',
  training: 'Latihan',
  disciplinary: 'Disiplin',
  skill: 'Kemahiran',
  contract: 'Kontrak',
  meeting: '1-on-1',
  reward: 'Ganjaran',
  exit: 'Exit Interview'
};

export const getTodayDate = () => new Date().toISOString().split('T')[0];

export const getLevelDiff = (required, current) => {
  const levels = ['Tiada', 'Asas', 'Sederhana', 'Mahir', 'Pakar'];
  return levels.indexOf(required) - levels.indexOf(current);
};
